import { Component, input, output } from '@angular/core';

import { Feature } from 'src/app/features/feature-management/models';

@Component({
  selector: 'app-alert-banner-expand',
  templateUrl: './alert-banner-expand.component.html',
  styleUrls: ['./alert-banner-expand.component.scss'],
  standalone: false
})
export class AlertBannerExpandComponent {
  protected readonly Feature = Feature;

  buttonAction = output();
  buttonName = input<string | undefined>();
  header = input<string | undefined>();
  isDisabled = input<boolean | true>();
  isExpanded = input<boolean | undefined>();
  type = input.required<string>();

  getBannerClass(type: string): string {
    switch (type) {
      case 'information':
        return 'info_banner';
      case 'success':
        return 'success_banner';
      case 'error':
        return 'error_banner';
      default:
        return '';
    }
  }

  handleButtonClick() {
    this.buttonAction.emit();
  }
}
